(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/button/link.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/button/link.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.payfooter = svs.tur.payfooter || {};
svs.tur.payfooter.button = svs.tur.payfooter.button || {};
svs.tur.payfooter.button.BECOME_CUSTOMER = 'Bli kund?';
class Link extends svs.tur.Base {
  constructor(_ref) {
    let {
      title = svs.tur.payfooter.button.BECOME_CUSTOMER,
      visible = true,
      callback,
      id
    } = _ref;
    super({
      title,
      callback,
      visible,
      id
    });
    this.log = new svs.core.log.Logger('payfooter:button:link');
    this.$a = this.createElement('tag', 'a');
    this.$a.innerText = this.title;
    this.$el.appendChild(this.$a);
    this.$a.addEventListener('click', e => {
      e.preventDefault();
      this.callback();
    });
  }
  classNames() {
    return ['payfooter-link'];
  }
}
svs.tur.payfooter.button.Link = Link;

 })(window);